<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">Projects List</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
                <json-excel 
                  class="btn btn-success"
                  style="float: right;"
                  :data="itemList"
                  :fields="exportFields"
                  name="project-list.xls"
                  >
                  Export
                </json-excel>
              <h4>
                <i class="fa fa-list-ul"></i>
                Project List
              </h4>
            </div>
          </div>
        </header>
      </section>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  PROJECT LIST
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    width=""
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Project Name</th>
                        <th width="10%">Customer Name</th>
                        <th width="10%">Address</th>
                        <th width="10%">Phone</th>
                        <th width="10%">Mobile</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in itemList"
                        :key="item.project_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ item.project_name }}</td>
                        <td>
                          {{ item.customer_name }}</td>
                        <td>
                          {{ item.project_address }}</td>
                        <td>
                          {{ item.project_phone }}</td>
                        <td>
                          {{ item.project_mobile }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Show pagination links -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import JsonExcel from "vue-json-excel";

export default {
  name: "ProjectList",

  components: {
    JsonExcel
  },
  data() {
    return {
      itemList: [],
      exportFields: {
        'Project': 'project_name',
        'Customer': 'customer_name',
        'Address': 'project_address',
        'Phone': 'project_phone',
        'Mobile': 'project_mobile'
      }
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_projects", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.projectList;
          }
        });
    }
  },
  mounted(){
    this.getList()
  }
};
</script>
